import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import DoneIcon from "@mui/icons-material/Done";
import PendingIcon from "@mui/icons-material/Pending";

import CustomButton from "../../helper-components/input/CustomButton";

import { defaultId, defaultStyle, defaultTime } from "./shared.js";
import { formatText } from "../shared/miscUtils.js";

// Render functions.
const renderEnabled = (params) => {
    const enabled = params.row.enabled;

    if (enabled === true) {
        return <CustomButton icon={<DoneIcon className="cursor-default" />} tooltip={"Enabled"} />;
    } else if (enabled === false) {
        return <CustomButton icon={<PendingIcon className="cursor-default" />} tooltip={"Not yet enabled"} />;
    }

    return <CustomButton icon={<QuestionMarkIcon className="cursor-default" />} tooltip={"Unknown"} />;
};

// Column definitions.
const username = { ...defaultStyle, field: "username", headerName: "Username", flex: 0.15, minWidth: 100 };
const email = { ...defaultStyle, field: "email", headerName: "Email", flex: 0.2, minWidth: 200 };
const enabled = { ...defaultStyle, field: "enabled", headerName: "Enabled", flex: 0.1, minWidth: 75, renderCell: (params) => renderEnabled(params) };
const role = { ...defaultStyle, field: "role.role", headerName: "Role", minWidth: 125, valueGetter: (params) => formatText(params.row.role?.role) };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const lastLogin = { ...defaultTime("last_login"), headerName: "Last login" };

// Table columns.
export const columns = (props) => [defaultId, username, email, enabled, role, createdOn, lastLogin];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
